import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ParameterConst } from '../util/constant';


@Injectable({
  providedIn: 'root'
})
export class DataserviceService {

  constructor(private httpClient : HttpClient) { }

  


}
